// NavigationDrawer : Left positioned for App Routes
// @group DefaultLayout
export default {
    props: {
        value: {
            type: Boolean
        },
    },
    data() {
        return {
            drawer: {
                // sets the open status of the drawer
                show        : this.value,
                // sets if the drawer is shown above (false) or below (true) the toolbar
                clipped     : false,
                // sets if the drawer is CSS positioned as 'fixed'
                fixed       : false,
                // sets if the drawer remains visible all the time (true) or not (false)
                temporary   : false,
                // sets the drawer to the mini variant, showing only icons, of itself (true)
                // or showing the full drawer (false)
                mini        : false,
                miniWidth   : '60'
            },
            menu: [
                {   title       : 'order-create',
                    icon        : 'mdi-file-edit-outline',
                    path        : '/order-create',
                },{
                    title       : 'title02',
                    icon        : 'mdi-wrench-outline',
                    path        : '/title02',
                },{
                    title       : 'title03',
                    icon        : 'mdi-barcode',
                    path        : '/title03',
                },{
                    title       : 'title04',
                    icon        : 'mdi-package-up',
                    path        : '/title04',
                },{
                    title       : 'title05',
                    icon        : 'build',
                    path        : '/title05',
                },{
                    title       : 'title06',
                    // icon        : 'mdi-check',
                    icon        : 'mdi-file-check-outline',
                    path        : '/title06',
                },{
                    title       : 'title07',
                    icon        : 'mdi-file-search-outline',
                    path        : '/title07',
                },{
                    title       : 'title08',
                    icon        : 'mdi-cash-usd-outline',
                    path        : '/title08',
                },{
                    title       : 'title09',
                    icon        : 'mdi-file-plus-outline',
                    path        : '/title09',
                },{
                    title       : 'software-license',
                    icon        : 'mdi-license',
                    path        : '/software-license',
                },
            ],
        };
    },
    computed: {
        computeLogo() {
            return "/static/svg/manor-logo.svg";
        },
        computeLogoSmall() {
            return "/static/png/manor-logo-small.png";
        },
    },
    methods: {
        onIconPinDrawerClick () {
            this.drawer.mini = !this.drawer.mini;
        },
        onNavigationItemClick () {
            if (!this.drawer.mini) {
                this.drawer.show = false;
            }
        },
        onNavigationDrawerToolbarClick () {
            if (this.drawer.mini) {
                this.drawer.mini = false;
            }
        },
    },
    watch: {
        value: function() {
            // console.info('value in drawer', this.value);
            // console.info('value in show', this.drawer.show);
            this.drawer.show = this.value;
        },
        '$vuetify.breakpoint.xl': function () {
            // Hide navigation drawer on MD and UP screen size
            // console.info('this resizing lg', this.$vuetify.breakpoint.width);
            // console.info('lg');
            // this.drawer.show        = true;
            this.drawer.mini        = false;
            this.drawer.permanent   = false;
            this.drawer.temporary   = false;
            this.drawer.fixed       = false;
        },
        '$vuetify.breakpoint.lg': function () {
            // Hide navigation drawer on MD and UP screen size
            // console.info('this resizing lg', this.$vuetify.breakpoint.width);
            // console.info('lg');
            // this.drawer.show        = true;
            this.drawer.mini        = false;
            this.drawer.permanent   = true;
            this.drawer.temporary   = false;
            this.drawer.fixed       = false;
            this.drawer.clipped     = false;
        },
        // // '$vuetify.breakpoint.mdAndDown': function () {
        '$vuetify.breakpoint.md': function () {
            // console.info('md');
            // console.info('breakpoint', this.$vuetify.breakpoint);
            // console.info('this resizing width', this.$vuetify.breakpoint.width);
            if (this.$vuetify.breakpoint.width < 960) {
                this.drawer.mini      = false;
                this.drawer.fixed     = false;
                this.drawer.permanent = false;
                this.drawer.temporary = false;
                this.drawer.clipped   = false;
                // this.drawer.show      = false;
            } else {
                // this.drawer.show      = true;
                this.drawer.mini      = true;
                this.drawer.fixed     = false;
                this.drawer.permanent = true;
                this.drawer.temporary = false;
                this.drawer.clipped   = false;
            }
        },
        '$vuetify.breakpoint.smAndUp': function () {
            // console.info('smAndUp');
            // console.info('breakpoint', this.$vuetify.breakpoint);
            // console.info('this resizing width', this.$vuetify.breakpoint.width);
            if (this.$vuetify.breakpoint.width < 600) {
                //show icon on toolbar
                // this.drawer.show      = false;
                this.drawer.mini      = false;
                this.drawer.fixed     = false;
                this.drawer.permanent = false;
                this.drawer.temporary = false;
                this.drawer.clipped   = false;
            } else {
                //hide icon on toolbar
                // this.drawer.show      = true;
                this.drawer.mini      = true;
                this.drawer.fixed     = false;
                this.drawer.permanent = true;
                this.drawer.temporary = false;
                this.drawer.clipped   = false;
            }
        },
        '$vuetify.breakpoint.xsAndDown': function () {
            // console.info('xsOnly');
            // console.info('breakpoint', this.$vuetify.breakpoint)
            // console.info('this resizing width', this.$vuetify.breakpoint.width)
            // this.drawer.show      = true;
            this.drawer.mini      = false;
            this.drawer.fixed     = false;
            this.drawer.permanent = false;
            this.drawer.temporary = false;
            this.drawer.clipped   = false;
        },
        // '$vuetify.breakpoint.xsAndDown': function () {
        //     this.drawer.mini        = false;
        //     this.drawer.fixed       = true;
        // },
        'drawer.show' :  function() {
            // console.info('---drawer channge---');
            this.$emit('input',  this.drawer.show);
        },
    },
    created() {
        console.info('create');
        if (localStorage.getItem('userDeveloperModus') == 'true') {
            this.menu.push(
                {
                    title       : '-- TEST --',
                    icon        : 'mdi-android-debug-bridge',
                    path        : '/test',
                }
            );
        }
    }
};

